import React, { useEffect, useState } from 'react';
import { v3_fat_documents, v3_fat_list } from '../../../actions/v3/fat';
import { v3_upload_plan_approval_document } from '../../../actions/v3/planApproval';
import moment from 'moment';
import constant from '../../../constant';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import { FaPlus, FaTrash } from 'react-icons/fa';
import RemarksSelect from '../../common/RemarksSelect';
import FileDropdownPreviewMenu from '../../common/FileDropdownPreviewMenu';
import customAxios from '../../../customHook/customAxios';
import { getAuthHeader } from '../../../utils';
import fileDownload from 'js-file-download';
import { uploadSelectedFiles } from '../../../utils/multipleFileUpload';
import AdminDeleteButton from '../../common/AdminDeleteButton';

const ACCEPTED_REPORT_RECEIVED_STATUS = 'Accepted, Report received';
const ACCEPTED_REPORT_RECIEVED_STATUS = 'Accepted, Report recieved';
const LEGACY_ACCEPTED_STATUS = 'Accepted';

const isAcceptedStatus = (status) =>
    status === LEGACY_ACCEPTED_STATUS || status === ACCEPTED_REPORT_RECEIVED_STATUS || status === ACCEPTED_REPORT_RECIEVED_STATUS;

const formatFatStatus = (status) =>
    status === LEGACY_ACCEPTED_STATUS || status === ACCEPTED_REPORT_RECIEVED_STATUS ? ACCEPTED_REPORT_RECEIVED_STATUS : status;

const toApiFatStatus = (status) =>
    status === ACCEPTED_REPORT_RECEIVED_STATUS || status === ACCEPTED_REPORT_RECIEVED_STATUS ? LEGACY_ACCEPTED_STATUS : status;

const statusClassMap = {
    'Passed': 'passed-ins',
    [LEGACY_ACCEPTED_STATUS]: 'accepted-ins',
    [ACCEPTED_REPORT_RECEIVED_STATUS]: 'accepted-ins',
    [ACCEPTED_REPORT_RECIEVED_STATUS]: 'accepted-ins',
    'Accepted with Comments': 'accepted-ins',
    'Scheduled': 'scheduled-ins',
    'In Progress': 'inprogress-ins',
    'Unscheduled': 'unscheduled-ins'
};

const decodeMojibake = (value) => {
    if (!value || typeof value !== 'string' || value.includes('�')) return value;

    const decodeOnce = (input) => {
        if (!/[\u00C0-\u00FF]/.test(input)) return input;
        if (typeof TextDecoder === 'undefined' || typeof TextEncoder === 'undefined') return input;

        try {
            const sourceBytes = Uint8Array.from(input, (ch) => ch.charCodeAt(0) & 0xff);
            const decoded = new TextDecoder('utf-8', { fatal: false }).decode(sourceBytes);
            if (!decoded || decoded.includes('\u0000')) return input;

            const reEncoded = new TextEncoder().encode(decoded);
            if (reEncoded.length !== sourceBytes.length) return input;

            for (let i = 0; i < reEncoded.length; i += 1) {
                if (reEncoded[i] !== sourceBytes[i]) return input;
            }

            return decoded;
        } catch (error) {
            return input;
        }
    };

    let current = value;
    for (let i = 0; i < 2; i += 1) {
        const next = decodeOnce(current);
        if (next === current) break;
        current = next;
    }

    return current;
};

const getUploadedFiles = (files = []) => (
    Array.isArray(files)
        ? files.filter((file) => file?.fileName && file?.originalFileName)
        : []
);

const getLatestRevisionDocuments = (item = {}) => (
    Array.isArray(item.LAST_REVISION_DOCUMENTS)
        ? item.LAST_REVISION_DOCUMENTS
        : []
);

const Fat = ({ projectId, shipId, setStatusCount, setTotal, filterPayload, onUpdateStatus, refresh, setRefresh, data, setData }) => {
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [total, setLocalTotal] = useState(0);
    const [fatId, setFatId] = useState('')
    const [documentsTouched, setDocumentsTouched] = useState(false);

    const [statusState, setStatusState] = useState({
        status: {
            name: 'status', value: '', error: '', options: ['Unscheduled', 'Scheduled', 'Not Applicable', 'Accepted with Comments', ACCEPTED_REPORT_RECEIVED_STATUS], isRequired: true
        },
        scheduled_date: {
            name: 'scheduled_date', value: '', error: '', isRequired: false
        },
        accepted_date: {
            name: 'accepted_date', value: '', error: '', isRequired: false
        },
        documentFiles: {
            name: 'documentFiles',
            value: [{ fileName: '', originalFileName: '' }],
            isRequired: false,
            error: ''
        },
        remarks: { name: 'remarks', value: '', error: '', isRequired: false },
    })

    const handleStatusStateChange = (e) => {
        const { name, value } = e.target;
        setStatusState(prev => {
            const next = {
                ...prev,
                [name]: { ...prev[name], value, error: '' }
            };

            if (name === 'status') {
                const isScheduled = value === 'Scheduled';
                const isAccepted = isAcceptedStatus(value) || value === 'Accepted with Comments';

                next.scheduled_date = {
                    ...next.scheduled_date,
                    isRequired: isScheduled,
                    error: isScheduled ? next.scheduled_date.error : '',
                    value: isScheduled ? next.scheduled_date.value : ''
                };
                next.accepted_date = {
                    ...next.accepted_date,
                    isRequired: isAccepted,
                    error: isAccepted ? next.accepted_date.error : '',
                    value: isAccepted ? next.accepted_date.value : ''
                };
            }

            return next;
        });
    };
    const replaceFileAtIndex = (index) => {
        const updatedFiles = [...statusState.documentFiles.value];
        updatedFiles[index] = { fileName: '', originalFileName: '' };
        setDocumentsTouched(true);
        setStatusState(prev => ({
            ...prev,
            documentFiles: { ...prev.documentFiles, value: updatedFiles, error: '' }
        }));
    };

    const handleFileChange = async (index, files) => {
        setDocumentsTouched(true);
        const uploadedFiles = await uploadSelectedFiles(files, v3_upload_plan_approval_document);
        if (!uploadedFiles.length) {
            toast.error('Failed to upload file.');
            return;
        }

        setStatusState(prev => {
            const updatedFiles = [...prev.documentFiles.value];
            updatedFiles.splice(index, 1, ...uploadedFiles.map((file) => ({ ...file, existing: false })));
            return {
                ...prev,
                documentFiles: { ...prev.documentFiles, value: updatedFiles, error: '' }
            };
        });
    };

    const addFileField = () => {
        setDocumentsTouched(true);
        setStatusState(prev => ({
            ...prev,
            documentFiles: {
                ...prev.documentFiles,
                value: [...prev.documentFiles.value, { fileName: '', originalFileName: '' }],
                error: ''
            }
        }));
    };

    const removeFileField = (index) => {
        setDocumentsTouched(true);
        const updatedFiles = statusState.documentFiles.value.filter((_, i) => i !== index);
        setStatusState(prev => ({
            ...prev,
            documentFiles: {
                ...prev.documentFiles,
                value: updatedFiles,
                error: updatedFiles.length === 0 ? 'At least one document is required' : ''
            }
        }));
    };
    const handleStatusUpdateSubmit = () => {

        // 1. Validate required fields
        let isValid = true;
        const updatedState = { ...statusState };

        Object.keys(statusState).forEach((key) => {
            if (statusState[key].isRequired && !statusState[key].value) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            }
        });

        setStatusState(updatedState);
        if (!isValid) {
            toast.error('Please fill all required fields.');
            return;
        }

        // 2. Build payload
        const payload = {
            remarks: statusState.remarks.value,
            remark: statusState.remarks.value,
            status: toApiFatStatus(statusState.status.value),
            scheduled_date: statusState.scheduled_date.value,
            accepted_date: statusState.accepted_date.value,
            fatId: fatId
        };
        if (documentsTouched) {
            payload.documentFiles = getUploadedFiles(statusState.documentFiles.value);
        }

        onUpdateStatus(payload)
    };

    const encodeFilterPayload = (payload) => {
        try {
            const json = JSON.stringify(payload);
            if (!json) return '';

            if (typeof TextEncoder !== 'undefined') {
                const bytes = new TextEncoder().encode(json);
                let binary = '';
                bytes.forEach((b) => {
                    binary += String.fromCharCode(b);
                });
                return btoa(binary);
            }

            // Fallback for older browsers.
            return btoa(unescape(encodeURIComponent(json)));
        } catch (error) {
            console.error('Failed to encode filter payload:', error);
            return '';
        }
    };

    useEffect(() => {
        // Reset when scope or filters change
        setPage(1);
        setData([]);
    }, [shipId, projectId, filterPayload]);

    useEffect(() => {
        let isCancelled = false;

        const encodedFilterPayload = encodeFilterPayload(filterPayload);
        v3_fat_list(page, limit, projectId, shipId, encodedFilterPayload).then((res) => {
            if (isCancelled) return;
            if (res.status) {
                if (page === 1) {
                    setData(res.result.fat);
                } else {
                    setData(prev => {
                        const updatedMap = new Map();

                        // First add all previous items
                        prev.forEach(item => {
                            updatedMap.set(item.ID, item);
                        });

                        // Then overwrite/add new items
                        res.result.fat.forEach(newItem => {
                            updatedMap.set(newItem.ID, newItem);
                        });

                        return Array.from(updatedMap.values());
                    });
                }
                setStatusCount(res.result.statusCount)
                setLocalTotal(res.result.total);
                if (setTotal) setTotal(res.result.total);
            }
        });
        return () => {
            isCancelled = true;
        };
    }, [page, limit, shipId, projectId, filterPayload, refresh]);

    useEffect(() => {
        if (!fatId) return;
        setDocumentsTouched(false);
        v3_fat_documents(fatId).then((res) => {
            if (res.status) {
                const mapped = (res.result.documents || []).map(doc => ({
                    fileName: doc.FILE_NAME || doc.fileName,
                    originalFileName: doc.ORIGINAL_FILE_NAME || doc.originalFileName,
                    existing: true
                }));
                setStatusState(prev => ({
                    ...prev,
                    documentFiles: {
                        ...prev.documentFiles,
                        value: mapped.length ? mapped : [{ fileName: '', originalFileName: '' }],
                        error: ''
                    }
                }));
            } else {
                toast.error(res.error || 'Failed to load documents.');
            }
        });
    }, [fatId]);

    const handleLoadMore = () => {
        if (data.length < total) {
            setPage(prev => prev + 1);
        }
    };

    const handleDownloadRevisionZip = async (item) => {
        if (!item?.ID || !item?.LAST_REVISION_ID) return;

        try {
            const downloadUrl = `${process.env.REACT_APP_BASE_URL}/v3/fat/document/zip/${item.ID}/${item.LAST_REVISION_ID}`;
            let config = { responseType: 'blob' };
            const authHeader = getAuthHeader();
            if (authHeader?.headers) {
                config.headers = {
                    ...config.headers,
                    ...authHeader.headers,
                };
            }
            const response = await customAxios.get(downloadUrl, config);
            const blob = new Blob([response.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `fatId_${item.ID}_revision_${item.LAST_REVISION_ID}_files.zip`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error?.response?.data || error.message);
            alert("Download failed. Please check if the document has valid files or contact support.");
        }
    };

    const handleDownloadFile = async (fatId, revisionId, fileName) => {
        try {
            const downloadUrl = `${process.env.REACT_APP_BASE_URL}/v3/fat/document/download/${fatId}/${revisionId}/${encodeURIComponent(fileName)}`;
            let config = { responseType: 'blob' };
            const authHeader = getAuthHeader();
            if (authHeader?.headers) {
                config.headers = {
                    ...config.headers,
                    ...authHeader.headers,
                };
            }
            const response = await customAxios.get(downloadUrl, config);
            fileDownload(response.data, fileName);
        } catch (error) {
            console.error('Download failed:', error?.response?.data || error.message);
            alert("Download failed. Please check if the document has valid files or contact support.");
        }
    };

    const buildRevisionFiles = (item) => {
        const revisionId = item?.LAST_REVISION_ID;
        return getLatestRevisionDocuments(item).map((doc, index) => {
            const rawFileName = doc.FILE_NAME || doc.fileName || '';
            const encodedFileName = encodeURIComponent(rawFileName);
            const displayName = decodeMojibake(doc.ORIGINAL_FILE_NAME || doc.originalFileName || rawFileName || `File ${index + 1}`);

            return {
                id: `${item.ID}-${revisionId}-${rawFileName || 'file'}-${index}`,
                name: displayName,
                previewUrl: rawFileName && revisionId
                    ? `${process.env.REACT_APP_BASE_URL}/v3/fat/document/preview/${item.ID}/${revisionId}/${encodedFileName}`
                    : '',
                downloadUrl: rawFileName && revisionId
                    ? `${process.env.REACT_APP_BASE_URL}/v3/fat/document/download/${item.ID}/${revisionId}/${encodedFileName}`
                    : '',
                onDownload: rawFileName && revisionId
                    ? () => handleDownloadFile(item.ID, revisionId, rawFileName)
                    : null,
            };
        });
    };

    console.log(data)

    return (
        <div className="hull-right-section">
            {data.map((item) => {
                const revisionFiles = buildRevisionFiles(item);

                return (
                    <div className="fat-hull-item" key={item.ID} onClick={() => { }}>
                    <div className="hull-top-box">
                        <div className="hull-top-left">
                            <h5> <Link
                                to={{
                                    pathname: constant.Authedcomponent.fatDetail.url,
                                    state: {
                                        projectId: item.PROJECT_ID,
                                        fatId: item.ID,
                                        projectName: item.PROJECT_NAME,
                                    }
                                }}
                            >{item.FAT_NUMBER} ({item.HULL_NUMBER} - {item.SHIP_NAME})
                            </Link>
                            </h5>
                            <h6>
                                <span>{item.COMPANY_NAME}</span> {item.SUBJECT}
                            </h6>
                        </div>
                        <div className="hull-top-right">
                            <p style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                                <AdminDeleteButton resource="fat" entryId={item.ID} label="FAT"
                                    className="btn btn-sm btn-outline-danger"
                                    onDeleted={(deletedId) => {
                                        setData(rows => rows.filter(row => row.ID !== deletedId));
                                        setRefresh(value => !value);
                                    }} />
                                <span>
                                    Revised on {moment(item.LAST_REVISION_CREATED_ON).format('YYYY-MM-DD')}
                                </span>
                                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <i className="bx bx-message"></i> {item.TOTAL_COMMENTS}
                                </span>
                                <span
                                    style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}
                                    onClick={() => setFatId(item.ID)}
                                    data-bs-toggle="modal"
                                    data-bs-target={`#statusUpdateModal`}
                                >
                                    <i className="bx bx-edit" style={{ fontSize: '20px' }}></i>
                                    Update Status
                                </span>
                                <Link
                                    to={
                                        {
                                            pathname: constant.Authedcomponent.fatEdit.url,
                                            state: {
                                                data: item,
                                                projectId
                                            }
                                        }
                                    }
                                    style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}
                                    onClick={() => setFatId(item.ID)}
                                >
                                    <i className="bx bx-edit" style={{ fontSize: '20px' }}></i>
                                    Edit
                                </Link>
                            </p>

                            <div
                                className="modal fade"
                                id={`statusUpdateModal`}
                                data-bs-backdrop="static"
                                data-bs-keyboard="false"
                                tabIndex={-1}
                                role="dialog"
                                aria-labelledby="statusUpdateModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="statusUpdateModalLabel">
                                                Update Status
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">
                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <label>Status {statusState.status.isRequired && <span className='text-danger'> *</span>}</label>
                                                    <select
                                                        name={'status'}
                                                        value={statusState['status'].value}
                                                        onChange={handleStatusStateChange}
                                                        className={`form-control ${statusState['status'].error ? 'is-invalid' : ''}`}
                                                    >
                                                        <option value=''>Select Status</option>
                                                        {statusState.status.options.map((status) => {
                                                            return (
                                                                <option value={status}>{status}</option>

                                                            )
                                                        })}
                                                    </select>
                                                    {statusState['status'].error && <div className="invalid-feedback">{statusState['status'].error}</div>}
                                                </div>

                                                {statusState.status.value === 'Scheduled' && <div className="col-md-12 mb-3">
                                                    <label>Scheduled Date {statusState.scheduled_date.isRequired && <span className='text-danger'> *</span>}</label>
                                                    <input
                                                        type='date'
                                                        name={'scheduled_date'}
                                                        value={statusState['scheduled_date'].value}
                                                        onChange={handleStatusStateChange}
                                                        className={`form-control ${statusState['scheduled_date'].error ? 'is-invalid' : ''}`}
                                                    />
                                                    {statusState['scheduled_date'].error && <div className="invalid-feedback">{statusState['scheduled_date'].error}</div>}
                                                </div>}
                                                {(isAcceptedStatus(statusState.status.value) || statusState.status.value === 'Accepted with Comments') && (
                                                    <div className="col-md-12 mb-3">
                                                        <label>Accepted Date {statusState.accepted_date.isRequired && <span className='text-danger'> *</span>}</label>
                                                        <input
                                                            type='date'
                                                            name={'accepted_date'}
                                                            value={statusState['accepted_date'].value}
                                                            onChange={handleStatusStateChange}
                                                            className={`form-control ${statusState['accepted_date'].error ? 'is-invalid' : ''}`}
                                                        />
                                                        {statusState['accepted_date'].error && <div className="invalid-feedback">{statusState['accepted_date'].error}</div>}
                                                    </div>
                                                )}

                                                <div className="col-md-12 mb-3">
                                                    <label>Upload Documents</label>

                                                    {statusState.documentFiles.value.map((item, index) => (
                                                        <div key={index} className="d-flex align-items-center mb-2">
                                                            {item.fileName ? (
                                                                <>
                                                                    <div className="me-2 flex-grow-1">
                                                                        <span>{decodeMojibake(item.originalFileName || item.fileName)}</span>
                                                                    </div>

                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-secondary me-2"
                                                                        onClick={() => replaceFileAtIndex(index)}
                                                                    >
                                                                        Replace
                                                                    </button>

                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-danger"
                                                                        onClick={() => removeFileField(index)}
                                                                    >
                                                                        <FaTrash />
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <input
                                                                        type="file"
                                                                        multiple
                                                                        onChange={(e) => handleFileChange(index, e.target.files)}
                                                                        className="form-control me-2"
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-danger"
                                                                        onClick={() => removeFileField(index)}
                                                                    >
                                                                        <FaTrash />
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    ))}

                                                    <div>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary"
                                                            onClick={addFileField}
                                                        >
                                                            <FaPlus className="me-1" /> Add Document
                                                        </button>
                                                    </div>

                                                    {statusState.documentFiles.error && (
                                                        <div className="text-danger mt-1">{statusState.documentFiles.error}</div>
                                                    )}
                                                </div>



                                                <RemarksSelect
                                                    label="Remarks"
                                                    name="remarks"
                                                    value={statusState.remarks.value}
                                                    onChange={handleStatusStateChange}
                                                    error={statusState.remarks.error}
                                                    required={statusState.remarks.isRequired}
                                                    placeholder="Enter remarks"
                                                />
                                            </div>
                                            <div className="mt-3">
                                                <button type="submit" className="btn btn-success me-2"
                                                    onClick={() => {
                                                        handleStatusUpdateSubmit()

                                                    }}
                                                >Submit</button>
                                                <button className="btn btn-danger text-white" onClick={() => {
                                                    const modal = window.bootstrap.Modal.getInstance(document.getElementById(`statusUpdateModal`));
                                                    if (modal) modal.hide();
                                                }}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="hull-bottom-info">
                        <h5 className={statusClassMap[item.STATUS] || ''}>
                            {formatFatStatus(item.STATUS)} | {item.CATEGORY_NAME}
                        </h5>
                        {item.STATUS === 'Scheduled' ? <p>
                            <span>Scheduled On:</span> {item.SCHEDULE_DATE ?? 'N/A'}
                        </p> : ""}
                        {item.ACCEPTED_DATE ? <p>
                            <span>Accepted On:</span> {item.ACCEPTED_DATE}
                        </p> : ""}
                        <p>
                            <span>Created By:</span> {item.CREATED_BY_NAME}
                        </p>
                        {/* You can replace below lines with real assignee logic */}
                        <p>
                            <span>Assignee:</span> {item.ASSIGNED_USER_NAME} ({item.ASSIGNED_USER_DESIGNATION_NAME})
                        </p>
                        <p>
                            <span>Latest Revision:</span> {item.LAST_REVISION_NAME || 'NA'}
                        </p>
                        <div className="dropdown hover-dropdown">
                            <p>
                                <span>Files:</span>{' '}
                                <span
                                    role="button"
                                    className="dropdown-toggle"
                                >
                                    {revisionFiles.length} File <i className="bx bx-download" />
                                </span>
                            </p>
                            <FileDropdownPreviewMenu
                                files={revisionFiles}
                                onDownloadAll={revisionFiles.length ? () => handleDownloadRevisionZip(item) : null}
                            />
                        </div>
                    </div>
                    </div>
                );
            })}

            {data.length < total && (
                <div className="text-center mt-3">
                    <button className="btn btn-outline-primary" onClick={handleLoadMore}>
                        Load More
                    </button>
                </div>
            )}
        </div>
    );
};

export default Fat;
